import {
  IconDefinition,
  faFacebook,
  faInstagram,
  faLinkedin,
  faRedditAlien,
  faTiktok,
  faTwitch,
  faWhatsapp,
  faXTwitter,
  faYoutube,
} from '@fortawesome/free-brands-svg-icons';
import { faEnvelope } from '@fortawesome/pro-regular-svg-icons';
import { faLink, faPlay } from '@fortawesome/pro-solid-svg-icons';
import { Brand, SocialName } from '@waitroom/models';
import { isFunction } from '@waitroom/utils';
import { ComponentType, ReactNode } from 'react';
import { Icon as IconC, IconProps as IconCProps } from '../modules/core/components/Icon/Icon';

export const icons: Record<Brand | SocialName | string, IconDefinition | ComponentType> = {
  [Brand.FACEBOOK]: faFacebook,
  [Brand.INSTAGRAM]: faInstagram,
  [Brand.LINKEDIN]: faLinkedin,
  [Brand.REDDIT]: faRedditAlien,
  [Brand.RESTREAM]: faPlay,
  [Brand.YOUTUBE]: faYoutube,
  [Brand.TIKTOK]: faTiktok,
  [Brand.TWITTER]: faXTwitter,
  [Brand.TWITCH]: faTwitch,
  [Brand.WHATSAPP]: faWhatsapp,
  email: faEnvelope,
  website: faLink,
  custom: faLink,
};

export const getIcon = (
  Icon: IconDefinition | ComponentType,
  iconProps: Partial<IconCProps> = {},
): ReactNode =>
  isFunction(Icon) ? <Icon p="5%" {...iconProps} /> : <IconC icon={Icon} {...iconProps} />;
